import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ContratoService } from 'src/app/services/contrato.service';
import { ProcesoMatriculaService } from 'src/app/services/procesomatricula.service';
import { ToastrService } from 'ngx-toastr';
import { UnificadoService } from 'src/app/services/unificado.service';
import { GlobalVariable } from 'src/app/config/service.config';

declare var $: any;

@Component({
  selector: 'app-cloudsignerfailed',
  templateUrl: './cloudsignerfailed.component.html',
  styleUrls: []
})
export class CloudsignerfailedComponent implements OnInit {

  Idproceso = '';
  titulo = 'Validando estado del contrato';
  body = 'Esperando...';
  progress = true;
  sending: boolean = false;
  constructor(
    private route: ActivatedRoute,
    private contratoservice: ContratoService,
    private procesoService: ProcesoMatriculaService,
    private unificadoService: UnificadoService,
    private alerts: ToastrService
  ) {
    // This is intentional
  }

  ngOnInit(): void {
    this.route.params.subscribe(
      param => {
        console.log('ngOnInit Iniciando');
        console.log('[CloudsignerfailedComponent] ds.params.id (ngOnInit)', param.id)
        this.Idproceso = param.id;
        this.cancelar_y_redirigir(param.id);
      },
    );
    console.log('this.route.parent.url.subscribe Iniciando', this.route.parent.url.subscribe);

    this.route.parent.url.subscribe((urlPath) => {
      console.log('ngOnInit Iniciando');
      const url = urlPath[urlPath.length - 1].path;
      console.log('[CloudsignerfailedComponent] url', url)
    })
  }

  handleProceso(idproceso: any) {
    this.contratoservice.getEstadoContrato(idproceso).subscribe(
      (data: any) => {
        console.log('[CloudsignerfailedComponent] getEstadoContrato', data)
        this.titulo = 'Estado del documento ' + data?.RetornoDesdeApi[0]?.glosa_estado_firma;
        this.progress = false;
        this.body = 'Estado del documento ' + data?.RetornoDesdeApi[0]?.glosa_estado_firma;
      },
      (err) => {
        this.body = 'Ha fallado la comunicación con el servicio de estado de contratos.'
        this.progress = false;
      },
      () => {
        // This is intentional
      }
    );
  }

  cancelar_y_redirigir(idproceso: any) {
    const urlInicio = `${GlobalVariable.BASE_API_URL}/inicio`
    console.log('cancelar_y_redirigir', urlInicio);
    this.procesoService.desactivaSimulacion(idproceso).subscribe(
      (data: any) => {
        setTimeout(() => {
          window.parent.location.href = urlInicio
        }, 10000)
      },
      (err) => {
        this.alerts.error('Ocurrió un error, intente nuevamente', 'Atención');
        console.log(err);
      },
    )
  }

  /********* Modales *********/
  openModalOpcionesContrato() {
    $('#modalOpcionesContrato').modal('show');
  }

  openConfirmCambioCarrera() {
    $('#modalOpcionesContrato').modal('show');
  }
  /********* Modales *********/

  /********* Operaciones de Modales *********/
  corregirDatosPersonales() {
    console.log('[CloudsignerfailedComponent] corregirDatosPersonales')
    // TODO: Falta setear la URL de PROD
    window.parent.location.href = `http://localhost:4200/proceso/${this.Idproceso}/cdp`
    $('#modalOpcionesContrato').modal('hide');
  }

  seleccionarOtraCarrera() {
    console.log('[CloudsignerfailedComponent] seleccionarOtraCarrera')
    this.openConfirmCambioCarrera();
    $('#modalOpcionesContrato').modal('hide');
    $('#modalConfirmCambioCarrera').modal('show');
  }

  handleSendingError(err) {
    console.log(err);
    this.alerts.error('Ocurrió un error, intente nuevamente', 'Atención');
    this.sending = false;
    $('#modalConfirmCambioCarrera').modal('hide');
  }

  async cambiarCarrera() {
    console.log('[CloudsignerfailedComponent] cambiarCarrera')

    this.sending = true;
    // Rechazar documento
    let opRes = true;
    await this.unificadoService.RechazarDocumento(this.Idproceso).toPromise().catch(err => {
      opRes = false;
      this.handleSendingError(err);
    });
    if (!opRes) {
      this.handleSendingError(null);
      return;
    }

    // Setear a fase 3
    await this.procesoService.setFase(this.Idproceso, '3').toPromise().catch(err => {
      opRes = false;
      this.handleSendingError(err);
    });
    if (!opRes) {
      this.handleSendingError(null);
      return;
    }

    this.alerts.success('Operación realizada');
    // TODO: Falta setear la URL de PROD
    window.parent.location.href = `http://localhost:4200/proceso/${this.Idproceso}`
    $('#modalConfirmCambioCarrera').modal('hide');
    this.sending = false;
  }

  cancelarPostulacion() {
    console.log('[CloudsignerfailedComponent] cancelarPostulacion')

    this.procesoService.desactivaSimulacion(this.Idproceso).subscribe(
      (data: any) => {
        this.alerts.success('Proceso cancelado');
        // TODO: Falta setear la URL de PROD
        window.parent.location.href = 'http://localhost:4200/inicio'
      },
      (err) => {
        this.alerts.error('Ocurrió un error, intente nuevamente', 'Atención');
        console.log(err);
      },
      () => {
        $('#modalOpcionesContrato').modal('hide');
      }
    )
  }
  /********* Operaciones de Modales *********/
}
